import { render, staticRenderFns } from "./ParametrizacaoControleVencimento.vue?vue&type=template&id=1fa633c7"
import script from "./ParametrizacaoControleVencimento.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoControleVencimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports